<template>
  <div class="gallery-com">
    <div class="gallery-box">
      <p class="tit">
        <span id="gallery-title">Gallery</span>
        <i @click="toback" class="el-icon-back"> </i>
      </p>
      <div class="pic-box">
        <div class="pic">
          <el-image
            lazy
            preview
            class="img"
            v-for="(item, index) in gallery"
            :key="index"
            :src="item.temp_photo_path_url"
            alt=""
            ><div slot="placeholder" class="image-slot">
              <i class="el-icon-loading"></i></div
          ></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["gallery"],
  data() {
    return {
      bigPic: []
      // log the gallery props
    };
  },
  methods: {
    toback() {
      this.$emit("toback");
    }
  }
};
</script>

<style lang="scss" scoped>
.gallery-com {
  width: 1260px;
  background: #fff;
  border-radius: 15px;
  box-shadow: 2px 2px 15px rgba(128, 128, 128, 0.5);
  padding: 30px;
  .gallery-box {
    width: 100%;
    .tit {
      font-size: 25px;
      color: #5aa2d3;
      font-weight: 600;
      text-align: left;
      margin: 20px 35px;
      display: flex;
      justify-content: space-between;
      .el-icon-back {
        cursor: pointer;
      }
    }
    .pic-box {
      height: 600px;
      overflow-y: scroll;
      .pic {
        display: flex;
        flex-wrap: wrap;
        .img {
          width: 23%;
          height: 100%;
          margin: 10px;
          border-radius: 15px;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .gallery-com {
    width: 100%;
    height: 696px;
    .gallery-box {
      .tit {
        margin: 0;
      }
      .pic-box {
        .pic {
          flex-direction: column;
          .img {
            width: 90%;
            margin: 10px 0;
          }
        }
      }
    }
  }
}
</style>
